import React, { useMemo, useRef } from "react";
import { Spin } from "antd";
import Style from "./index.module.scss";
import { v4 } from "uuid";

interface FileUploaderProps {
    buttonClass?: string;
    buttonText?: string;
    loading?: boolean;
    onFileSelect: (files: File[]) => void;
    children?: React.ReactChild;
    multiple?: boolean;
}

export default function FileSelect({
    buttonClass,
    loading,
    children,
    buttonText = "点击上传",
    onFileSelect,
    multiple = true
}: FileUploaderProps) {
    const fileRef = useRef<any>(null);
    function onChange() {
        onFileSelect(fileRef.current.files);
    }
    function onClick() {
        fileRef.current.value = "";
    }
    const id = useMemo(() => {
        return v4();
    }, []);
    return (
        <div className={buttonClass} onClick={onClick}>
            {!children && (
                <Spin spinning={loading}>
                    <div className={Style.btn}>
                        {!loading && <label htmlFor={id}>{buttonText}</label>}
                    </div>
                </Spin>
            )}
            {children && <label htmlFor={id}>{children}</label>}
            <input
                ref={fileRef}
                type="file"
                id={id}
                style={{ display: "none" }}
                multiple={multiple}
                onChange={onChange}
            />
        </div>
    );
}
